<template>
  <div class="right-home add-connect public-content">
    <div class="breadcrumb">添加关联</div>
    <div class="right-main">
      <!--      查询订单-->
      <el-form :inline="true" :model="formInline" label-width="90px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="产品名称:">
              <el-input v-model="formInline.spuName" placeholder="请输入订单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="SKU组名称:">
              <el-input v-model="formInline.skuGroupName" placeholder="请输入订单号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品类别:">
              <el-select v-model="formInline.categoryId" placeholder="请选择" clearable>
                <el-option v-for="item in categoryList" :key='item.id' :value="item.key" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item class="current-platform">
              <!--              {{formInline.order}}-->
              <span><b>当前平台号: </b>{{ storeMsg.code }}</span>
              <span style="margin-left: 20px;"><b>当前平台名称: </b>{{ storeMsg.companyName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="onSubmit" round>查询</el-button>
            <el-button class="search-ok" @click="Relate" round type="primary">关联</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="platformNum" label="SKU组code" min-width="10px">
          </el-table-column>
          <el-table-column prop="username" label="SKU组名称" min-width="10px">
          </el-table-column>
          <el-table-column prop="platformNum" label="产品名称" min-width="10">
          </el-table-column>
          <el-table-column prop="platformName" label="SKU组图片" min-width="10">
          </el-table-column>
          <el-table-column prop="payDate" label="属性组合" min-width="10">
          </el-table-column>
          <el-table-column prop="payDate" label="产品类别" min-width="10">
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination :queryInfo='queryInfo' class="v-pagination"></v-pagination>
    </div>
  </div>
</template>
 <script>
import VPagination from '@/components/Pagination/index.vue'
import { useCurrentUser } from '@/api/crm'
import { skuGroupAssociate, categoryList } from '@/api/pms'
export default {
  name: 'add-connect',
  components: {
    VPagination
  },
  inject: ['reload'],
  data () {
    return {
      categoryList: [],
      queryInfo: {
        pageNum: 1,
        pageSize: 10
      },
      formInline: {
        categoryId: '',
        skuGroupId: '',
        skuGroupName: '',
        spuName: '',
        storeId: 0
      },
      tableData: [],
      value2: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      gridData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海'
      }],
      storeMsg: {
        companyName: '',
        code: ''
      }
    }
  },
  created () {
    this.getStoreMsg()
    this.getSkuList()
  },
  methods: {
    getCategoryList () {
      categoryList().then(res => {
        this.categoryList = res.data.data
      })
    },
    getSkuList () {
      skuGroupAssociate({ flag: 1, pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, platSkuGroupVo: this.formInline }).then(res => {
        ;
        if (res.success) {
          this.tableData = res.data.records
        }
      })
    },
    getStoreMsg () {
      useCurrentUser().then(res => {
        this.storeMsg = res.data.data.store
        this.formInline.storeId = res.data.data.id
      })
    },
    onSubmit () {
      // 向后台发送post请求,获取查询数据存储在tableData
      //
      this.$axios.post().then((res) => {
      })
    },
    getPlatformStatus (status) {
      if (status === '审核') {
        this.$router.push('./checkplatform')
      }
      if (status === '查看/编辑') {
        this.$router.push('./editplatform')
      }
    },
    Relate () {
    },
    addPlateform () { },
    handleSelectionChange () { }
  }
}
</script>
 <style scoped lang="less">
 @import "index";
 @deep: ~">>>";
 </style>
